/**
 * Events emitted in the context of uwc-input
 *
 * @internal
 * @module
 */

import { createEventNameProxy } from "@hesxenon/prelude/Dom.js";
import { ValueElement } from "./parts/value-element.js";

export const Events = createEventNameProxy<
  UwcInputElement,
  [
    "suggestionSelected",
    "selectedChanged",
    "formValuesChanged",
    "validityStateChanged",
    "clear",
    "formReset",
    "formAssociated",
    "init",
  ]
>();

declare global {
  interface HTMLElementEventMap {
    [Events.suggestionSelected]: CustomEvent<ValueElement>;
    [Events.formValuesChanged]: CustomEvent<FormDataEntryValue[]>;
    [Events.validityStateChanged]: CustomEvent<ValidityStateFlags>;
  }
}
